import React from "react";

const DevsIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 10.2363L10 0.236328L20 10.2363H0Z" fill="#B8E986" />
      <path d="M12.5 10.2363H7.5V20.2363H12.5V10.2363Z" fill="#B8E986" />
    </svg>
  );
};

export default DevsIcon;
